export const MODEM_TYPE = {
  LOAN: 'Loan',
  REFURBISHED: 'Refurbished',
  FOR_SALE: 'ForSale'
}
